import React, { useEffect, useState, useRef } from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import PirceSlider from "../../../components/rental-list/sidebar/PirceSlider";
import InputRange from "react-input-range";
import PriceRange from '../../../components/staycations/PirceSlider';

const CarSideBar = ({ setIsFilter, currency, setIsPriceChange, filterFunction, handleClearFilter, priceData, setPriceData, sortData, setSortData, activityType, setActivityType, priceData1, setPriceData1, filterData, setFilterDataOne, filterDataOne, setLoder }) => {
  const [data, setData] = useState({
    type: 1,
    seat: "",
    gearShift: "",
    distance: "",
    payment: "",
    corporate_id: 0,
    pickup_latitude: 0.0,
    pickup_longitude: 0.0,
    drop_latitude: 0.0,
    drop_longitude: 0.0,
    company_id: 0,
    model_id: 1,
  });

  const [name, setName] = useState([]);
  const [rangeLowHigh, setRangeLowHigh] = useState('');

  function handleFilter(index, type, title, demo) {
    setIsFilter(true)
    const obj = {
      "title": title,
      "type": type,
      "filters": [{
        "name": demo.name,
        "type": true
      }]
    }

    const newArray = [...activityType];
    const newArray1 = [...name];

    newArray[index] = obj;
    newArray1[index] = demo?.name;

    const filteredData = newArray.filter(item => item !== null);

    // newArray.splice(index, 0, obj);
    // newArray1.splice(index, 0, demo?.name);

    setActivityType(filteredData);
    setName(newArray1);
  }


  const handleOnChange = (value) => {
    setSortData(value);
    setIsPriceChange(true)

    const temp = [{ sort: value }];
    setRangeLowHigh(value);
    setFilterDataOne(temp);
  };



  const handleClear = () => {
    setName([]);
    handleClearFilter();
    setRangeLowHigh('');
  }

  return (
    <div className="y-gap-40">
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "center"
      }}>
        <h5 className="text-16 fw-500">Filter</h5>
        {
          (rangeLowHigh !== "" || name?.length > 0) &&
          <button
            onClick={handleClear}
            className="clearBtn"
            style={{
              color: "#50B2A9",
              width: '40px',
              // height: '40px',
              borderRadius: "6px",
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            clear
          </button>
        }
      </div>
      <hr style={{
        margin: '0px',
        padding: '0px'
      }}></hr>
      <div>
        <h5 className="text-16 fw-500 mb-10">Price Range</h5>
        <div className="row y-gap-10 items-center justify-between">
          <div className="col-auto">
            <div className="form-radio ">
              <div className="radio d-flex items-center">
                <input
                  type="radio"
                  name="sort"
                  value={3}
                  onClick={() => handleOnChange(3)}
                  checked={rangeLowHigh === 3 ? true : false}
                />
                <div className="radio__mark">
                  <div className="radio__icon" />
                </div>
                <div className="ml-10 text-15 fw-300">Low To High</div>
              </div>
            </div>
          </div>
        </div>
        <div className="row y-gap-10 items-center justify-between">
          <div className="col-auto">
            <div className="form-radio ">
              <div className="radio d-flex items-center">
                <input
                  type="radio"
                  name="sort"
                  value={7}
                  onClick={() => handleOnChange(7)}
                  checked={rangeLowHigh === 7 ? true : false}
                />
                <div className="radio__mark">
                  <div className="radio__icon" />
                </div>
                <div className="ml-10 text-15 fw-300">High To Low</div>
              </div>
            </div>
          </div>
        </div>
        {/* <PriceRange currency={currency} setIsPriceChange={setIsPriceChange} priceData={priceData} setPriceData={setPriceData} priceData1={priceData1} setPriceData1={setPriceData1} /> */}
      </div>

      {filterData && filterData.map((item, inx) => (
        <div className="mt-10" key={inx}>
          <h5 className="text-16 fw-500 mb-10">{item?.title}</h5>
          <div className="row y-gap-10 items-center justify-between" key={inx}>
            <div className="col-auto">
              <div className="form-radio ">
                <div className="radio d-flex items-center">
                  <input
                    type="radio"
                    name="type"
                    value={1}
                    onClick={() => handleFilter(0, "All", "All", "All")}
                  // checked={demo.name === name ? true : false}
                  />
                  <div className="radio__mark">
                    <div className="radio__icon" />
                  </div>
                  <div className="ml-10 text-15 fw-300">All</div>
                </div>
              </div>
            </div>
          </div>
          {item?.filters.map((demo, index) => (
            <div className="row y-gap-10 items-center justify-between" key={index}>
              <div className="col-auto">
                <div className="form-radio ">
                  <div className="radio d-flex items-center">
                    <input
                      type="radio"
                      name="type"
                      // value={demo.name}
                      onClick={() => handleFilter(inx, item.type, item.title, demo)}
                      checked={demo.name === name[inx] ? true : false}
                    />
                    <div className="radio__mark">
                      <div className="radio__icon" />
                    </div>
                    <div className="ml-10 text-15 fw-300">{demo.name}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}


        </div>
      ))}



    </div>
  );
};

export default CarSideBar;
